"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * ForecastChangeProductDTO converter.
 *
 * @author OPt
 * @author Adam Drda
 */


var ForecastChangeProductDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ForecastChangeProductDTOConverter, _DataObjectConverter_);

  function ForecastChangeProductDTOConverter() {
    _classCallCheck(this, ForecastChangeProductDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ForecastChangeProductDTOConverter).apply(this, arguments));
  }

  return ForecastChangeProductDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ForecastChangeProductDTOConverter = ForecastChangeProductDTOConverter;